<template>
  <AppHeader />
  <main class="container sm:px-8">
    <slot />
  </main>
</template>

<script setup lang="ts">
import AppHeader from '@/components/_common/AppHeader.vue';
</script>
